module.exports = __webpack_public_path__ + "img/Oberperfuss1.72e00cf7.jpg";